<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <cashback-report-table></cashback-report-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import cashbackReportTable from './CashbackReportTable.vue'

  export default {
    name: 'cashbackReport',
    components: {cashbackReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/cashbackReport/CashbackReport.vue